import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'longmoon-terrain',
  templateUrl: './terrain.component.html',
  styleUrls: ['./terrain.component.scss']
})
export class TerrainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
